import { LoadableLazy } from '@confluence/loadable';

export const ConfluenceSmartCreationModalLoader = LoadableLazy({
	name: 'ConfluenceSmartCreationModalLoader',
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConfluenceSmartCreationModalManager" */ '../src/ConfluenceSmartCreationModalManager'
			)
		).ConfluenceSmartCreationModalManager,
});
